
import { Link } from "react-router-dom";

interface Product {
  id: number;
  name: string;
  price: number;
  slug: string;
  image: string;
}

interface FooterRecommendedProductsProps {
  products: Product[];
}

const FooterRecommendedProducts = ({ products }: FooterRecommendedProductsProps) => {
  return (
    <div>
      <h4 className="text-md md:text-lg font-medium mb-4">Products We Recommend</h4>
      <div className="space-y-3 max-h-[300px] md:max-h-[400px] overflow-y-auto pr-2">
        {products.map((product) => (
          <Link key={product.id} to={product.slug} className="flex items-center gap-2 md:gap-3 group">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded overflow-hidden flex-shrink-0">
              <img 
                src={product.image} 
                alt={product.name} 
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs md:text-sm font-medium group-hover:text-primary transition-colors truncate">{product.name}</p>
              <p className="text-xs md:text-sm text-muted-foreground">${product.price.toFixed(2)}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FooterRecommendedProducts;
